import { useState } from "react";
import { getUserInfo } from "services/authService";
import userImage from "../assets/images/home-decor-1.jpg";
// font-awesome
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import MDButton from "components/MDButton";
import ResetPassword from "layouts/super_admin/admin/modals/ResetPassword";
import { useTranslation } from "hooks/useTranslation";
import { useMaterialUIController } from "context";

function UserProfile() {
  const { t } = useTranslation();
  const user = getUserInfo();
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [controller] = useMaterialUIController();
  const { miniSidenav } = controller;

  if (!user) return null;

  const handleResetPasswordOpen = () => {
    setOpenResetPassword(true);
  };

  const handleResetPasswordClose = () => {
    setOpenResetPassword(false);
  };

  const getTranslatedRole = (role) => {
    const normalizedRole = String(role || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/_/g, "");

    if (normalizedRole === "superadmin" || normalizedRole === "superadministrator") {
      return t("navigation.superAdmin", "Super Admin");
    }
    if (normalizedRole === "admin") {
      return t("navigation.admin", "Admin");
    }
    if (normalizedRole === "annotator") {
      return t("navigation.annotator", "Annotator");
    }

    return role;
  };

  return (
    <>
      <div style={{ padding: "10px", color: "white" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6",
            justifyContent: miniSidenav ? "center" : "flex-start",
          }}
        >
          <FontAwesomeIcon icon={faUser} fontSize="large" style={{ flexShrink: 0 }} />
          {!miniSidenav && (
            <div style={{ marginLeft: "10px", minWidth: 0, overflow: "hidden" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: user.full_name && user.full_name.length > 20 ? "11px" : "14px",
                  lineHeight: 1.3,
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                {user.full_name}
              </div>
              <div style={{ fontSize: "12px", textTransform: "uppercase" }}>
                {getTranslatedRole(user.role)}
              </div>
            </div>
          )}
        </div>
        {!miniSidenav && user.role === "SuperAdmin" && (
          <MDButton
            variant="outlined"
            color="white"
            size="small"
            onClick={handleResetPasswordOpen}
            fullWidth
            sx={{ mt: 2 }}
          >
            {t("superAdmin.modals.resetPassword", "Reset Password")}
          </MDButton>
        )}
      </div>
      {user.role === "SuperAdmin" && (
        <ResetPassword
          open={openResetPassword}
          onClose={handleResetPasswordClose}
          user={user}
          onSuccess={() => {
            console.log("Password reset successfully");
          }}
        />
      )}
    </>
  );
}
export default UserProfile;
